var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTr15(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2894,
    height: 544,
    viewBox: "0 0 2894 544",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1575_1908)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 271.312,
    cy: 271.875,
    r: 271.312,
    fill: "#00AA6C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1107.86 271.875C1107.86 409.23 996.511 520.578 859.156 520.578V23.1719C996.511 23.1719 1107.86 134.52 1107.86 271.875ZM859.156 543.188C1009 543.188 1130.47 421.717 1130.47 271.875C1130.47 122.033 1009 0.5625 859.156 0.5625C709.314 0.5625 587.844 122.033 587.844 271.875C587.844 421.717 709.314 543.188 859.156 543.188Z",
    fill: "#00AA6C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1447,
    cy: 271.875,
    r: 260.008,
    stroke: "#00AA6C",
    strokeWidth: 22.6094
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2034.84,
    cy: 271.875,
    r: 260.008,
    stroke: "#00AA6C",
    strokeWidth: 22.6094
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2622.69,
    cy: 271.875,
    r: 260.008,
    stroke: "#00AA6C",
    strokeWidth: 22.6094
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1575_1908"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2894,
    height: 542.625,
    fill: "white",
    transform: "translate(0 0.5625)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTr15);
export default __webpack_public_path__ + "static/media/tr-1.5.d63e809c2cba1c8d6ae3b3bbe9e3a307.svg";
export { ForwardRef as ReactComponent };